// The maximum quanity of a variant allowed to be purchased
export const PURCHASE_QUANTITY_MAX = 15